import { render } from "./HomeAvatar.vue?vue&type=template&id=eb581b06&scoped=true"
import script from "./HomeAvatar.vue?vue&type=script&lang=js"
export * from "./HomeAvatar.vue?vue&type=script&lang=js"

import "./HomeAvatar.vue?vue&type=style&index=0&id=eb581b06&scoped=true&lang=scss"
import "./HomeAvatar.vue?vue&type=style&index=1&id=eb581b06&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_webpack@5.112.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb581b06"]])

export default __exports__